import BASEURLGESTTOR from '../api/gesttor'
import { cadastrarSubTarefaPayload, atualizarSubTarefaPayload } from '../../interfaces/subTarefas'


export function novaSubTarefa (idTarefa: number, payload: cadastrarSubTarefaPayload) {
    return BASEURLGESTTOR.post(`/subtarefas/${idTarefa}`, payload)
} 

export function listarSubtarefas (idTarefa: string) {
    return BASEURLGESTTOR.get (`/subtarefas/${idTarefa}`)
}

export function atualizarSubTarefa (idSubTarefa: number, payload: atualizarSubTarefaPayload) {
    return BASEURLGESTTOR.patch(`/subtarefas/${idSubTarefa}`, payload)
}

export function deletarSubTarefa (idSubTarefa: number) {
    return BASEURLGESTTOR.delete(`/subtarefas/${idSubTarefa}`)
}

